<template>
  <v-col cols="6" sm="4" md="2">
    <v-card class="primary darken-1 sensor351-card">
      <v-row class="align-start justify-start ml-2 mr-2">
        <h4>{{ cardTitle }}</h4>
        <v-col cols="1">
          <v-icon style="color: lightgrey" left small>restore</v-icon>
        </v-col>
        <v-col cols="10">
          <span style="color: lightgrey; font-size: small">Atualizado em {{ formattedDateTime }}  </span>
        </v-col>
      </v-row>
      <v-card-title class="mt-n5">
        <v-icon color="secondary" class="mb-2">
          mdi-ruler
        </v-icon>
      </v-card-title>
      <v-card-subtitle class="font-weight-bold white--text">Régua do Reservatório</v-card-subtitle>
      <v-card-text>
        <v-row v-if="!sensorData">
          <v-col cols="3">
            <v-icon color="orange" right>mdi-information-outline</v-icon>
          </v-col>
          <v-spacer/>
          <v-col cols="9">
            <span style="color: orange">Os dados do sensor 351 estão indisponíveis no momento.</span>
          </v-col>
        </v-row>
        <v-row v-else class="white--text">
          <v-col cols="12">
            <strong class="display-1 font-weight-bold">
              {{ sensorValue }}
            </strong>
            <span class="font-weight-thin title" v-if="sensorData && sensorData.leitura">m</span>
          </v-col>
          <!-- <v-col cols="12" class="pt-0">
            <v-btn
              small
              text
              color="secondary"
              @click="openImageModal"
              class="px-0"
            >
              Ver imagem da régua
            </v-btn>
          </v-col> -->
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showImageModal" max-width="900px">
      <v-card class="primary darken-1">
        <v-card-title class="white--text">
          <v-icon color="secondary" left>mdi-ruler</v-icon>
          Imagem da Régua - Piraquara II
          <v-spacer></v-spacer>
          <v-btn icon @click="showImageModal = false">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle class="white--text pt-2">
          <span v-if="imageDateTime">Data da imagem: {{ imageDateTime }}</span>
          <span v-else>Imagem do reservatório Piraquara II</span>
        </v-card-subtitle>
        <v-card-text class="pt-4">
          <v-row justify="center" class="mb-3">
            <v-col cols="12" class="text-center">
              <v-btn icon color="secondary" @click="zoomOut">
                <v-icon>mdi-minus</v-icon>
              </v-btn>
              <span class="white--text mx-3">{{ Math.round(zoom * 100) }}%</span>
              <v-btn icon color="secondary" @click="zoomIn">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
              <v-btn icon color="secondary" @click="resetZoom" class="ml-2">
                <v-icon>mdi-restore</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="12">
              <div
                ref="imageContainer"
                class="image-container"
                @mousedown="handleMouseDown"
                @mousemove="handleMouseMove"
                @mouseup="handleMouseUp"
                @mouseleave="handleMouseUp"
              >
                <div class="image-wrapper" ref="imageWrapper">
                  <img
                    ref="image"
                    :src="rulerImageUrl"
                    alt="Imagem da régua do reservatório Piraquara II"
                    class="zoom-image"
                    @load="onImageLoad"
                  />
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import moment from "moment";

export default {
  name: "ReservoirRuler",
  props: ['sensorData', 'rulerImageInfo', 'cardTitle'],
  data() {
    return {
      showImageModal: false,
      zoom: 1,
      isDragging: false,
      startX: 0,
      startY: 0,
      scrollLeft: 0,
      scrollTop: 0
    };
  },
  computed: {
    sensorValue() {
      if (!this.sensorData || this.sensorData.leitura === null || this.sensorData.leitura === undefined) {
        return '---';
      }
      return this.sensorData.leitura.toFixed(2);
    },
    formattedDateTime() {
      if (!this.sensorData || !this.sensorData.datahora) {
        return '##/##/#### ##:##';
      }
      return moment(this.sensorData.datahora).format('DD/MM/YYYY HH:mm');
    },
    rulerImageUrl() {
      const url = (this.rulerImageInfo && this.rulerImageInfo.imageUrl)
        ? this.rulerImageInfo.imageUrl
        : '/riak/monitoring-sanepar/25484909_latest.png';

      return url;
    },
    imageDateTime() {
      if (!this.rulerImageInfo || !this.rulerImageInfo.measurement_date) {
        return null;
      }
      return moment(this.rulerImageInfo.measurement_date).format('DD/MM/YYYY HH:mm');
    }
  },
  methods: {
    openImageModal() {
      this.showImageModal = true;
      this.$nextTick(() => {
        this.resetZoom();
      });
    },
    zoomIn() {
      if (this.zoom < 3) {
        this.zoom = Math.min(3, this.zoom + 0.25);
        this.applyZoom();
      }
    },
    zoomOut() {
      if (this.zoom > 1) {
        this.zoom = Math.max(1, this.zoom - 0.25);
        this.applyZoom();
        if (this.zoom === 1) {
          this.centerImage();
        }
      }
    },
    resetZoom() {
      this.zoom = 1;
      this.applyZoom();
      this.centerImage();
    },
    applyZoom() {
      if (this.$refs.imageWrapper) {
        this.$refs.imageWrapper.style.transform = `scale(${this.zoom})`;

        if (this.zoom > 1) {
          this.$refs.imageWrapper.style.transformOrigin = 'top center';
          if (this.$refs.imageContainer) {
            this.$refs.imageContainer.style.cursor = 'grab';
          }
        } else {
          this.$refs.imageWrapper.style.transformOrigin = 'center center';
          if (this.$refs.imageContainer) {
            this.$refs.imageContainer.style.cursor = 'default';
          }
        }
      }
    },
    centerImage() {
      if (this.$refs.imageContainer) {
        this.$refs.imageContainer.scrollLeft = 0;
        this.$refs.imageContainer.scrollTop = 0;
      }
    },
    onImageLoad() {
      this.centerImage();
    },
    handleMouseDown(e) {
      if (this.zoom > 1) {
        this.isDragging = true;
        const container = this.$refs.imageContainer;
        this.startX = e.pageX - container.offsetLeft;
        this.startY = e.pageY - container.offsetTop;
        this.scrollLeft = container.scrollLeft;
        this.scrollTop = container.scrollTop;
        container.style.cursor = 'grabbing';
      }
    },
    handleMouseMove(e) {
      if (!this.isDragging) return;
      e.preventDefault();
      const container = this.$refs.imageContainer;
      const x = e.pageX - container.offsetLeft;
      const y = e.pageY - container.offsetTop;
      const walkX = (x - this.startX) * 2;
      const walkY = (y - this.startY) * 2;
      container.scrollLeft = this.scrollLeft - walkX;
      container.scrollTop = this.scrollTop - walkY;
    },
    handleMouseUp() {
      this.isDragging = false;
      if (this.$refs.imageContainer) {
        this.$refs.imageContainer.style.cursor = this.zoom > 1 ? 'grab' : 'default';
      }
    }
  }
}
</script>

<style scoped>
.sensor351-card.v-card.v-sheet.theme--dark {
  min-height: 306px;
  min-width: 150px;
  max-height: 350px;
  max-width: 350px;
}

.image-container {
  width: 100%;
  height: 600px;
  overflow: auto;
  cursor: default;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.zoom-image {
  display: block;
  max-width: 100%;
  max-height: 600px;
  width: auto;
  height: auto;
  object-fit: contain;
  user-select: none;
  -webkit-user-drag: none;
}
</style>